var map = {
	"./arrow-left.svg": "337d",
	"./arrow-right.svg": "e524",
	"./bao-icon.svg": "79fd",
	"./bowl-icon.svg": "cd81",
	"./burger-icon.svg": "722b",
	"./dot.svg": "1e63",
	"./download-black.svg": "718b",
	"./download.svg": "c482",
	"./kebab-icon.svg": "ce8a",
	"./pizza-icon.svg": "4e4e",
	"./sushi-icon.svg": "ebe4",
	"./white-arrow-left.svg": "282f",
	"./white-arrow-right.svg": "d223",
	"./wrap-icon.svg": "1493"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";